import {connect} from '@store/@common';
import {authUser} from '@store/auth';
import {
  libraryFormState,
  libraryId,
  librarySources,
  libraryTagToDelete,
  libraryShareAccessible,
  librarySearchCalls,
  librarySearchInfo,
  librarySearchType,
} from '@store/library';
import {libraryCreateForm} from '@store/library-form';
import LibraryActions from 'actions/library/LibraryActions';
import CrmSyncActions from 'actions/crm/CrmSyncActions';

import {LibrarySearchResults} from './LibrarySearchResults';

const mapStateToProps = {
  createForm: libraryCreateForm,
  user: authUser,
  libraryId,
  shareAccessible: libraryShareAccessible,
  sources: librarySources,
  formState: libraryFormState,
  searchCalls: librarySearchCalls,
  searchInfo: librarySearchInfo,
  searchType: librarySearchType,
  libraryTagToDelete,
};

const mapDispatchToProps = {
  fetchLibrariesData: async () => {
    await Promise.all([
      CrmSyncActions.crmSupportsCloud(),
      LibraryActions.getLibraries(),
      LibraryActions.getTags(),
      LibraryActions.getRecentTags(),
      LibraryActions.getCommonTags(),
      LibraryActions.getShareItems(),
      LibraryActions.getShareAccessibleDepartments(),
      LibraryActions.getShareAccessibleTeams(),
    ]);
  },
  updateLibraryDropdown: LibraryActions.updateLibraryDropdown.defer,
  updateLibrarySearchType: LibraryActions.updateLibrarySearchType.defer,
  searchCallsDefer: LibraryActions.searchCalls.defer,
  updateSearchingCalls: LibraryActions.updateSearchingCalls,
  clearSearchInfo: LibraryActions.clearSearchInfo,
};

export default connect(LibrarySearchResults, mapStateToProps, mapDispatchToProps);
